import { internal } from '../../vendor/elix.js';

function DisableableMixin(Base) {

  return class Disableable extends Base {

    static get observedAttributes() {
      return [
        ...super.observedAttributes,
        'disabled'
      ];
    }

    get [internal.defaultState]() {
      return Object.assign(
        {},
        super[internal.defaultState],
        { disabled: false }
      );
    }

    attributeChangedCallback(attributeName, oldValue, newValue) {
      super.attributeChangedCallback(attributeName, oldValue, newValue);
      if (attributeName === 'disabled') {
        this.disabled = newValue;
      }
    }

    get disabled() {
      return this[internal.state].disabled;
    }

    set disabled(disabled) {
      const isDisabled = disabled === true || disabled === 'true' || this.hasAttribute('disabled');
      this[internal.setState]({ disabled: isDisabled });
    }

    [internal.render](changed) {

      super[internal.render](changed);

      if (changed.disabled) {
        this.renderDisabledState();
      }

    }

    renderDisabledState() {
  
      const inputStateContainer = this.shadowRoot.querySelector('.inputStateContainer');

      if (inputStateContainer) {
        if (this.disabled) {
          inputStateContainer.classList.add('disabled');
        } else {
          inputStateContainer.classList.remove('disabled');
        }
      }

      const inner = this.shadowRoot.querySelector(this.innerSelector || '#inner');
      if (inner) {
        inner.disabled = this.disabled;
      }


    }

  }
}

export default DisableableMixin;
